import { ReactNode } from 'react';

import TooltipBox from '@/components/Tooltip/TooltipBox';
import TooltipButton from '@/components/Tooltip/TooltipButton';
import TooltipWrapper from '@/components/Tooltip/TooltipWrapper';

type TypeOptions = 'small' | 'medium' | 'large' | 'big' | 'left' | 'right' | 'center';

export type Props = {
  type?: TypeOptions | TypeOptions[];
  onClick?: () => void;
  boxClassname?: string;
  buttonSize?: 'small' | 'medium' | 'large';
  children?: ReactNode;
};

const Tooltip = ({ type, onClick, children, boxClassname, buttonSize = 'small' }: Props) => {
  return (
    <TooltipWrapper type={type} onClick={onClick}>
      <TooltipButton buttonSize={buttonSize} />
      <TooltipBox className={boxClassname}>{children}</TooltipBox>
    </TooltipWrapper>
  );
};

export default Object.assign(Tooltip, {
  Wrapper: TooltipWrapper,
  Box: TooltipBox
});
